module.exports = __webpack_public_path__ + "static/Renu_Sud_Karnad.6696c508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Renu_Sud_Karnad.jpg
// module id = 238
// module chunks = 118785002076118 245315906658106